module.exports = __webpack_public_path__ + "img/dokanios-250.a5f464fa.jpg";